import React, { memo, forwardRef } from "react";
const SvgCapitalRho = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M12.376 9.016v5.496h2.52c2.64 0 3.96-.928 3.96-2.784 0-1.808-1.304-2.712-3.912-2.712h-2.568zM11.416 7h3.768c1.904 0 3.392.392 4.464 1.176 1.072.768 1.608 1.952 1.608 3.552 0 1.632-.568 2.84-1.704 3.624-1.12.784-2.616 1.176-4.488 1.176h-2.688v6.312c0 .496-.128.848-.384 1.056-.256.192-.52.288-.792.288-.288 0-.56-.096-.816-.288-.256-.208-.384-.56-.384-1.056V8.416C10 7.472 10.472 7 11.416 7z"
      />
    </svg>
  );
});
SvgCapitalRho.displayName = "SvgCapitalRho";
const MemoForwardRef = memo(SvgCapitalRho);
export default MemoForwardRef;
